import React, { useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FwPlugins, { IFrame, usePluginReducer } from 'framework-plugins';
import Helmet from 'react-helmet';
import { PageWrapper } from 'dashboard';

const OperazioniMassive = ({ ufficioSelezionato }) => {
    const [dettaglio, setDettaglio] = useState();


    usePluginReducer(() => ({
        APERTA_LISTA_OPERAZIONI: () => setDettaglio(null),
        'APERTA OPERAZIONE': ({ Servizio, Operazione }) => setDettaglio(`${Servizio}-${Operazione}`),
    }));

    return (<React.Fragment>
        <PageWrapper
            className="monitor-operazioni-lunghe"
            helmetTitle="Monitoraggio elaborazioni"
            pageTitle={dettaglio == null ? "Monitoraggio elaborazioni" : dettaglio}
            pageBack
        >
            <IFrame
                src={`${window.config.urlOperazioni}/`}
                srcParams={{ ufficioSelezionato: ufficioSelezionato.CodiceUfficio, embedded: true }}
                inMemoryRouting
                updateHash={false}
            />
        </PageWrapper>

    </React.Fragment>);
};

const mapStoreToProps = store => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
});

OperazioniMassive.propTypes = {
  ufficioSelezionato: PropTypes.shape({
    CodiceUfficio: PropTypes.string,
  }).isRequired,
};

export default connect(mapStoreToProps)(OperazioniMassive);
